/**
 * Serialize default dashboards map to a comma-separated string
 * Format: "app_id:dashboard_id,app_id:dashboard_id"
 */
export function serializeDefaultDashboards(
  dashboards: Record<string, string>
): string {
  return Object.entries(dashboards)
    .map(([appId, dashboardId]) => `${appId}:${dashboardId}`)
    .join(',');
}

/**
 * Deserialize comma-separated string to default dashboards map
 * Format: "app_id:dashboard_id,app_id:dashboard_id"
 */
export function deserializeDefaultDashboards(
  serialized?: string
): Record<string, string> {
  if (!serialized) {
    return {};
  }

  const dashboards: Record<string, string> = {};
  const pairs = serialized.split(',');

  for (const pair of pairs) {
    const [appId, dashboardId] = pair.split(':');
    if (appId && dashboardId) {
      dashboards[appId] = dashboardId;
    }
  }

  return dashboards;
}

/**
 * Get default dashboard ID for a specific application
 */
export function getDefaultDashboard(
  serialized?: string,
  applicationId?: string
): string | undefined {
  if (!serialized || !applicationId) {
    return undefined;
  }

  const dashboards = deserializeDefaultDashboards(serialized);
  return dashboards[applicationId];
}

/**
 * Set default dashboard for a specific application
 */
export function setDefaultDashboard(
  currentSerialized: string | undefined,
  applicationId: string,
  dashboardId: string | undefined
): string {
  const dashboards = deserializeDefaultDashboards(currentSerialized);

  if (dashboardId) {
    dashboards[applicationId] = dashboardId;
  } else {
    delete dashboards[applicationId];
  }

  return serializeDefaultDashboards(dashboards);
}
